<template>
  <div class="relative w-full">
    <div v-if="$slots.prefix" class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground">
      <slot name="prefix" />
    </div>
    <input
      v-bind="$attrs"
      :value="modelValue"
      :class="cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm',
        'placeholder:text-muted-foreground',
        'focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors',
        $slots.prefix ? 'pl-9' : '',
        $slots.suffix ? 'pr-9' : '',
        props.class
      )"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <div v-if="$slots.suffix" class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground">
      <slot name="suffix" />
    </div>
  </div>
</template>

<script setup>
import { cn } from '@/lib/utils'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: { type: [String, Number], default: '' },
  class: { type: String, default: '' },
})
defineEmits(['update:modelValue'])
</script>
